module.exports = __webpack_public_path__ + "img/icon-use-secureship-yellow.e46adc1a.svg";